module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-CN":{"label":"查看 AI 推荐的尺码"}}')
  delete Component.options._Ctor
}
